const BELL_SOURCE = 'bell'

export const bellContactPath = (clientId) => `/contact/${clientId}?activeTab=notes&from=${BELL_SOURCE}`

export const openedFromBell = (search) => new URLSearchParams(search).get('from') === BELL_SOURCE
